export enum EcrDeviceCategoryEnum {
    TARM = 0,
    TAM = 1,
}

export function ecrDeviceCategoryEnumLabel(value: EcrDeviceCategoryEnum): string {
    switch (value) {
        case EcrDeviceCategoryEnum.TARM:
            return "enum.ecrDeviceCategory.tarm";
        case EcrDeviceCategoryEnum.TAM:
            return "enum.ecrDeviceCategory.tam";
        default:
            return "common.unknown";
    }
}